// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"a875140b","265":"ebb3008c","306":"29e31538","408":"06d5bea5","453":"da6dd0a5","535":"048c4ed7","616":"aa94692c","680":"414ca068","682":"768b87ac","716":"40a665b6","830":"78ba1f80","880":"725332e7"}[chunkId] + ".chunk.js";
};